import { Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material'
import styled from 'styled-components'

export type RadioPropsType = MuiRadioProps

const Radio = styled(MuiRadio)<RadioPropsType>``

export default Radio
